/*
 * Barra lateral aberta ou fechada pelo botão de hambúrguer.
 *
 * Do tablet para cima (≥ 768px) ela fica encaixada ao lado do conteúdo, e a escolha do
 * leitor vai para o localStorage; enquanto ele não escolheu, vale o padrão do
 * admin. No celular ela vira o painel do hambúrguer, por cima do conteúdo,
 * que começa fechado a cada página.
 */
import { forumBool } from './settings';
const STORAGE_KEY = 'canela.sidebarOpen';
const DOCKED_QUERY = '(min-width: 768px)';
export const SHELL_CLASS = 'Canela';
export const OPEN_CLASS = 'Canela--sidebarOpen';
export const OVERLAY_CLASS = 'Canela--sidebarOverlay';
let dockedChoice = null;
let overlayOpen = false;
function readStoredChoice() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === null ? null : stored === '1';
  } catch {
    return null;
  }
}
export function isDocked() {
  return window.matchMedia(DOCKED_QUERY).matches;
}
export function isSidebarOpen() {
  if (!isDocked()) return overlayOpen;
  if (dockedChoice === null) {
    dockedChoice = readStoredChoice() ?? forumBool('canelaSidebarOpenDefault', true);
  }
  return dockedChoice;
}
export function applySidebarState() {
  const app = document.getElementById('app');
  if (!app) return;
  app.classList.toggle(OPEN_CLASS, isSidebarOpen());
  app.classList.toggle(OVERLAY_CLASS, !isDocked() && overlayOpen);

  // Painel fechado com um menu aberto (navegou, Esc): a rolagem volta ao normal.
  if (!overlayOpen) {
    const aside = document.getElementById('canela-sidebar');
    aside?.classList.remove('CanelaSidebar--menuOpen');
    aside?.style.removeProperty('--canela-panel-scroll');
  }
}
export function toggleSidebar() {
  if (isDocked()) {
    dockedChoice = !isSidebarOpen();
    try {
      localStorage.setItem(STORAGE_KEY, dockedChoice ? '1' : '0');
    } catch {
      // Sem armazenamento a escolha vale só até recarregar a página.
    }
  } else {
    overlayOpen = !overlayOpen;
  }
  applySidebarState();
}

/** Fecha o painel sobreposto — ao navegar ou clicar fora dele. */
export function closeOverlaySidebar() {
  if (!overlayOpen) return;
  overlayOpen = false;
  applySidebarState();
}
export function watchViewport() {
  window.matchMedia(DOCKED_QUERY).addEventListener('change', () => {
    overlayOpen = false;
    applySidebarState();
  });
}
flarum.reg.add('ramon-canela', 'forum/utils/sidebarState', { SHELL_CLASS: SHELL_CLASS,OPEN_CLASS: OPEN_CLASS,OVERLAY_CLASS: OVERLAY_CLASS,isDocked: isDocked,isSidebarOpen: isSidebarOpen,applySidebarState: applySidebarState,toggleSidebar: toggleSidebar,closeOverlaySidebar: closeOverlaySidebar,watchViewport: watchViewport, });